import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { Button } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';
import { connect } from 'react-redux';
import { initials as getInitials } from '@Containers/Header/HeaderComponentSelectors';
import HoverTooltip from '@Components/HoverTooltip';
import Catalyst from '@Services/Catalyst';
import NamedUserContainer from './NamedUserContainer';

import './NamedUser.scss';

function NamedUser({ initials }) {
  const flyoutRef = useRef(null);

  const closeFlyout = useCallback(() => {
    flyoutRef.current?.toggleVisibility(false);
  }, []);

  return (
    <li className="u-els-padding-left-1o2 rx-menu-item--user u-els-display-none@tablet">
      <Flyout
        placement="bottom-end"
        pointer
        pointerType="primary"
        showCloseButton
        shouldCloseOnESC
        ref={flyoutRef}
        flyout={
          <div className="u-els-margin-right-3x">
            <NamedUserContainer closeFlyout={closeFlyout} />
          </div>
        }>
        <HoverTooltip id="reaxys-access-tooltip" tooltip="Reaxys Access" tooltipPlace="bottom-end" theme="simple">
          <Button
            data-e2e="named-user-dropdown-button"
            id="logged-in-user-dropdown-button"
            type="transparent"
            className="u-els-background-color-n7 profile-dd rounded-circle rx-cursor-pointer"
            aria-label="Profile"
            onClick={() => {
              Catalyst.trackContentLinkClick('header:icon:user');
              noop();
            }}>
            {initials}
          </Button>
        </HoverTooltip>
      </Flyout>
    </li>
  );
}

NamedUser.propTypes = {
  initials: PropTypes.string,
};

const mapStateToProps = (state) => ({
  initials: getInitials(state),
});

export default connect(mapStateToProps)(NamedUser);
